import React from "react";
import PropTypes from "prop-types";
import {
  DialysisDragDropContext,
  useDialysisDragDrop,
} from "./DialysisDragDrop.utils";
import { THEME } from "./DialysisDragDrop.constants";
import { Table } from "./Table";
import "./style.scss";

export function DialysisDragDrop(props) {
  const setTheme = () => {
    if (props.theme === THEME.DARK) return "";
    else return props.theme.toLowerCase();
  };

  React.useEffect(() => {
    props.setHeadingAriaLabel ? props.setHeadingAriaLabel() : null;
  }, []);

  return (
    <DialysisDragDropContext.Provider value={useDialysisDragDrop(props)}>
      <div className={`${setTheme()} dialysisDragDrop`} style={props.style}>
        <Table
          id={props.id}
          table={props.dialysisTable}
          headingAriaLabel={props.headingAriaLabel}
          dialysisRange={props.dialysisRange}
          feedbackType={props.feedbackType}
          responses={props.responses}
          xAxisLabel={props.xAxisLabel}
        />
      </div>
    </DialysisDragDropContext.Provider>
  );
}

DialysisDragDrop.propTypes = {
  /**
   * Component id from the notebook data file
   */
  id: PropTypes.number,
  /**
   * Title instruction to show on top of dialysis table
   */
  title: PropTypes.string,
  /**
   * High/Low values of Dialysis Table Ladders
   */
  dialysisRange: PropTypes.shape({
    /**
     * The lowest Ladder value
     */
    bottom: PropTypes.number,
    /**
     * The highest Ladder value
     */
    top: PropTypes.number,
  }),
  /**
   * Data for dialysis table
   */
  dialysisTable: PropTypes.arrayOf(PropTypes.object),
  /**
   *  Function to invoke on Dialysis position update
   */
  onDialysisUpdate: PropTypes.func,
  /**
   * Function to invoke when a Dialysis band is clicked to select it
   */
  onDialysisSelect: PropTypes.func,
  /**
   * Style object to set on application wrapper
   */
  style: PropTypes.object,
  /**
   * Theme for the component
   */
  theme: PropTypes.oneOf(["LIGHT", "DARK"]),
  /**
   * AriaLabel of the heading
   */
  headingAriaLabel: PropTypes.shape({
    /**
     * Unique key for the data
     */
    key: PropTypes.number,
    /**
     * Label of the Heading
     */
    label: PropTypes.string,
    /**
     * Arialabel to display on the heading
     */
    ariaLabel: PropTypes.string,
  }),
  /**
   * Function used to generate ariaLabel
   * onloading the component
   */
  setHeadingAriaLabel: PropTypes.func,
};

DialysisDragDrop.defaultProps = {
  style: {},
  theme: THEME.DARK,
};
